module.exports = __webpack_public_path__ + "static/media/folderIcon.416df3df.svg";